import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
export default function Mentorship() {
  return (
    <div>
      <div className='team-hero mentor-hero'>
        <Navbar />
        <div className='container texty'>
          <h1 >Mentorship Program</h1>
          <p>Our AMIMUN Mentorship program pairs budding MUN enthusiasts with seasoned mentors who will help in mastering essential skills like research, leadership, public speaking, and diplomacy. Through workshops, mock debates, and personalized guidance, we aim to elevate confidence and expertise to outshine any diplomatic conference. We provide an opportunity to connect with a number of MUN experts and learn from guest speakers. Whether you are a novice or experienced delegate, our program will elevate your diplomatic game and prepare you for success in the world of Model United Nations. Don't miss this chance to grow as a leader and make your mark in international affairs!</p>
        </div>
      </div>
      <h1 className='mentor-head'>Join Mentorship Program</h1>
      <div className='formframe container'>
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfV6ROYCowN1dqVldaesAthPx-s9ijoW26pdiAHTGwPn91hiQ/viewform?embedded=true" width="100%" height="600">Loading…</iframe>

      </div>
      <Footer/>
    </div>
  )
}
